module.exports = __webpack_public_path__ + "static/media/2.272ebccb.jpg";